import { createFileRoute } from '@tanstack/react-router';
import { EatsDashboardPage } from '@/pages/eats-dashboard';
import { requireAuth } from '../require-auth';

// No loader prefetch: every Eats query is keyed by the merchant/branch scope,
// which resolves from a hook once the branch list loads (see
// `useMerchantScope`). Prefetching here would fire with an empty scope, so the
// page's own queries own the fetch and render their widgets' skeletons.
export const Route = createFileRoute('/eats/')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  component: EatsDashboardPage,
});
